<div class="widget-error" data-testid="widget-error-container">

  <div class="widget-error__card">
    <div class="widget-error__badge" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 8v5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
        <circle cx="12" cy="16.6" r="1.3" fill="currentColor" />
        <circle cx="12" cy="12" r="9.2" stroke="currentColor" stroke-width="2.2" />
      </svg>
    </div>

    <h1 class="widget-error__title" data-testid="widget-error-title">Invalid API key</h1>

    <p class="widget-error__text">
      This widget could not be loaded because the <code>api_key</code> query parameter is missing or not valid.
    </p>

    <p class="widget-error__text">
      For assistance, please visit
      <a [href]="supportUrl" target="_blank" rel="noopener noreferrer"
         data-testid="widget-error-support-link">gpstuner.com</a>
      to contact our support team.
    </p>
  </div>

</div>
